import { IState } from "../..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../../app/store";
import { AccessorialRevenueDailyTrendState } from "../ShipmentReconciliationState";
import ShipmentReconciliationService from "../../../app/data/shipment-reconciliation/shipmentReconciliationService";
import { AccessorialRevenueTrendRequest } from "../../../app/data/shipment-reconciliation/models";

const initialState: AccessorialRevenueDailyTrendState = {
  loading: false,
  loadingFailed: false,
  loaded: false,
  results: []
};

const shipmentReconciliationService = ShipmentReconciliationService.getInstance();

export const accessorialRevenueDailyTrendSlice = createSlice({
  name: "accessorialRevenueDailyTrendSlice",
  initialState,
  reducers: {
    resetAccessorialRevenueDailyTrendState: (state) => initialState,
    accessorialRevenueDailyTrendLoadingStarted: (state) => {
      state.loading = true;
      state.loadingFailed = false;
      state.loaded = false;
    },
    accessorialRevenueDailyTrendLoadingSucceed: (state, { payload }) => {
      state.loaded = true;
      state.loading = false;
      state.loadingFailed = false;
      state.results = (payload && payload.trends) ? payload.trends : [];
    },
    accessorialRevenueDailyTrendLoadingFailed: (state, { payload }) => {
      state.loading = false;
      state.loadingFailed = true;
    }
  },
});

export const {
  resetAccessorialRevenueDailyTrendState,
  accessorialRevenueDailyTrendLoadingStarted,
  accessorialRevenueDailyTrendLoadingSucceed,
  accessorialRevenueDailyTrendLoadingFailed,
} = accessorialRevenueDailyTrendSlice.actions;

export const accessorialRevenueDailyTrendSelector = (state: IState) => state.accessorialRevenueDailyTrend;

export const getAccessorialRevenueDailyTrend = (
  requestData: AccessorialRevenueTrendRequest,
  onError?: (error: string) => void
): AppThunk => async (dispatch) => {
  dispatch(accessorialRevenueDailyTrendLoadingStarted());
  const response = await shipmentReconciliationService.getAccessorialRevenueDailyTrend(requestData);
  if (response.ok() && response.data) {
    dispatch(accessorialRevenueDailyTrendLoadingSucceed(response.data));
  } else {
    let error = "Internal Server Error, re-try the action or contact support";
    if (response && response.data && response.data.message) error = JSON.stringify(response.data.message);
    dispatch(accessorialRevenueDailyTrendLoadingFailed(error));
    onError && onError(error)
  }
};

const accessorialRevenueDailyTrendReducer = accessorialRevenueDailyTrendSlice.reducer;
export default accessorialRevenueDailyTrendReducer;